module.exports = __webpack_public_path__ + "static/media/gerberanew.d6e6b212.webp";